export enum AppTheme {
  Theme1 = '1',
  Theme2 = '2',
  Theme3 = '3',
  Theme4 = '4',
  Theme5 = '5',
  Theme6 = '6',
}

export enum ThemeMode {
  Dark = 'dark',
  Light = 'light',
}
